module.exports = __webpack_public_path__ + "static/media/Basurero.f1e97dbb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/agent/Tabs/Payments/img/Basurero.svg
// module id = 6493
// module chunks = 16